export const styles = {
  wrapper: {
    padding: '44px 20px',
    background: '#F9F9FF',
    // height: '600px'
    width: '100%',
  },
  container: {
    background: '#FFFFFF',
    display: 'flex',
    flexDirection: 'column',
    padding: 24,
  },
  spaceBetween: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  title: {
    color: '#011533',
    fontSize: 24,
    fontWeight: 600,
  },
  reload: {
    '& img': {
      cursor: 'pointer',
    },
  },
  filtersWrapper: {
    marginTop: 24,
    marginBottom: 10,
    display: 'flex',
  },
  filter: {
    width: 240,
    marginRight: '20px',
  },
  weekProps: {
    color: '#011533',
    marginRight: '30px',
    display: 'flex',
    flexDirection: 'column',

    '& > div:first-child': {
      fontSize: '14px',
      color: '#0000008a',
      lineHeight: '18px',
    },
    '& > div:nth-child(2)': {
      fontSize: '18px',
      color: '#011533',
      marginTop: '10px',
    },
  },
}
